import React, { useState, useCallback, useEffect } from 'react'
import debounce from "lodash/debounce";
import { Autocomplete, TextField } from '@mui/material';
import BottomPopper from '../BottomPopper';

const MercadappRemoteAutocomplete = ({ onChange, label, noOptionsText, renderOption, loadOptionsFunction, ...props }) => {
  const [options, setOptions] = useState([])
  const [inputValue, setInputValue] = useState(null)
  const [value, setValue] = useState()
  const [isLoading, setIsLoading] = useState(false)

  // eslint-disable-next-line
  const getOptionsDelayed = useCallback(
    debounce((text, callback) => {
      setIsLoading(true)
      setOptions([]);
      loadOptionsFunction(text).then(callback).finally(() => setIsLoading(false));
    }, 500),
    []
  );

  useEffect(() => {
    if (inputValue) {

      getOptionsDelayed(inputValue, (filteredOptions) => {
        setOptions(filteredOptions);
      });
    }
  }, [inputValue, getOptionsDelayed]);

  return <Autocomplete
    {...props}
    loading={isLoading}
    noOptionsText={noOptionsText}
    options={options}
    disablePortal={true}
    onChange={(_e, selected) => {
      setInputValue(null)
      setValue(selected)
      onChange(selected)
    }}
    PopperComponent={(props) => <BottomPopper props={props} />}
    inputValue={inputValue || value}
    onInputChange={(_, value, reason) => {
      if (reason !== 'reset') {
        setOptions([])
        setInputValue(value);
      }
    }}
    renderInput={(params) => <TextField {...params} label={label} variant="standard" InputLabelProps={{ shrink: true }} />}
    {...props}
  />

}

export default MercadappRemoteAutocomplete